export default function React_Sass() {
  return (
    <div>
      <h1>React_Sass Component</h1>
      <p>This is the React_Sass tutorial page.</p>
    </div>
  );
}
